export const scrollToBottom = (id) => {
  const element = document.querySelector(id);
  element?.scrollTo({ top: element.scrollHeight, behavior: 'smooth' });
};
